import React from 'react';
import Routes from '../routes';

// import 'sanitize.css/sanitize.css';
const App = () => <Routes />;

export default App;
